import React from "react";
import AdminLayout from "./AdminLayout";
import UserManagement from "./UserManagement";


function Users() {
    return (
        <AdminLayout>

            <UserManagement />
        </AdminLayout>
    );
}

export default Users;
